<template>
    <popup :opened="dataToShow" @close="close">

        <!-- BEGIN Content modal add referent -->
        <div>
            <div class="my-5 mx-20 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32">
                <h3 class="mb-10 text-pink-600">Supprimer le CV</h3>
                <h6 class="text-indigo-600 mb-10">Êtes-vous sûr de vouloir supprimer le CV {{((cvToDelete) ? '“'+cvToDelete.name+'“' : '')}} ?</h6>

                <div class="flex space-x-5 justify-center">
                    <action-button
                        border-color="border-pink-600"
                        text-color="text-pink-600"
                        bg-color="bg-pink-100"
                        bg-color-square="bg-pink-100"
                        :uppercase="true"
                        libelle="Annuler"
                        @clickAction="close(false)"
                    />
                    <action-button
                        border-color="border-transparent"
                        text-color="text-white"
                        bg-color="bg-pink-600"
                        bg-color-square="bg-pink-600"
                        icon-color="text-white"
                        :uppercase="true"
                        libelle="Supprimer"
                        type-shadow="shadow-pink"
                        @clickAction="removeCV(cvToDelete)"
                    />
                </div>
            </div>
        </div>
        <!-- END Content modal add referent -->
    </popup>
</template>

<script>
import Popup from './../../../components/Popup';
import ActionButton from './../../../components/ActionButton';
import Icon from './../../../components/Icon';

export default {
  name:'RemoveCvPopup',

  props:{
    dataToShow: Boolean,
    cvToDelete:Object,
  },

  data() {
    return {
      //
    };
  },

  components:{
    Popup,
    ActionButton,
    Icon,
  },

  computed:{
    //
  },

  methods:{

    close(){
      this.$emit('close');
    },

    removeCV(){
      this.$emit('removeCV', this.cvToDelete);
    },
  }
};
</script>
